<template>
  <v-card outlined>
    <v-card-title> {{ label }}: {{ party.name }}</v-card-title>
    <v-card-text>
      <h3>Organisation Details</h3>
      <v-row>
        <v-col cols="6">
          <v-text-field
            v-model="party.name"
            label="Organisation Name"
            :rules="[validateRequired]"
            @change="update"
          />
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="party.abn"
            label="ABN/ACN"
            :rules="[validateRequired]"
            @change="update"
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="party.address"
            label="Address"
            :rules="[validateRequired]"
            @change="update"
          />
        </v-col>
      </v-row>
      <v-divider class="mb-2" />
      <div>
        <h3>Signatories</h3>
        <v-row
          v-for="signatory in signatories"
          :key="signatory.userId"
        >
          <v-col cols="6">
            <v-text-field
              v-model="signatory.name"
              label="Signatory Name"
              :rules="[validateRequired]"
              @change="update"
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="signatory.companyTitle"
              label="Title in Organisation"
              :rules="[validateRequired]"
              @change="update"
            />
          </v-col>
          <v-col cols="12">
            <v-divider />
          </v-col>
        </v-row>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { validateRequired } from '@/utils/validationRules'

export default {
  name: 'StandardBusinessParty',
  props: {
    party: {
      type: Object,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {}
  },
  computed: {
    signatories() {
      return this.party.signatories
    }
  },
  methods: {
    validateRequired,
    update() {
      this.$emit('update', this.party)
    }
  }
}
</script>
